<template>
    <el-dialog
        title="添加考试"
        :visible.sync="visible"
        width="8.1rem"
        class="step-audit-dialog"
        key="exam"
        :before-close="handleExamDialogClose">
        <el-form :model="form" :rules="rules" ref="examDialogForm" :inline="true" key="4" class="user-step-split-form">
            <el-form-item label="考试名称：" class="form-left-item" prop="title">
                <el-input v-model="form.title" placeholder="请输入考试名称"></el-input>
            </el-form-item>
            <el-form-item label="考试时长：" class="form-right-item" prop="limitTime">
                <el-input v-model="form.limitTime" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="合格分数线：" class="form-left-item" prop="qualifiedScore">
                <el-input v-model="form.qualifiedScore" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="允许考试次数：" class="form-right-item" prop="limitNum">
                <el-input v-model="form.limitNum" placeholder="0，则不限制考试次数"></el-input>
            </el-form-item>
            <el-form-item label="考试进出截止时间：" class="form-left-item" prop="timeRange">
                <el-date-picker
                    v-model="form.timeRange"
                    type="daterange"
                        placeholder="请选择考试进出截止时间"
                    class="job-time-item"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label=" 查看试卷规则：" class="form-left-item" prop="checkRule">
                <el-radio-group v-model="form.checkRule">
                    <el-radio :label="1">显示得分</el-radio>
                    <el-radio :label="2">显示标准答案与得分</el-radio>
                    <el-radio :label="3">显示标准答案、得分、试题解析</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <div class="step-exam-border">
            <el-button size="mini" @click="examTypeChange(1)">试题组卷</el-button>
            <el-button size="mini" @click="examTypeChange(2)">随机组卷</el-button>
            <el-button size="mini" @click="examTypeChange(3)">选择试卷</el-button>
        </div>
        <div class="step-exam-border">当前组卷方式：{{typeObj[type]}}</div>
        <div class="training-step-table step-exam-border">
            <score-table :questionItems="questionItems"></score-table>
        </div>
        <div class="dialog-footer">
            <el-button type="primary" size="mini" @click="handleExamDialogSave('examDialogForm')">保存</el-button>
        </div>
    </el-dialog>
</template>
<script>
import scoreTable from './scoreTable'

export default {
    name: 'examDailog',
    props: ['visible', 'questionItems', 'examPaperId', 'configIds'],
    components: { scoreTable },
    data() {
        return {
            form: {
                title: '',
                limitTime: '',
                qualifiedScore: '',
                limitNum: '',
                timeRange: [],
                checkRule: 1,
            },
            rules: {
                title: [
                    { required: true, message: '请输入考试名称', trigger: 'change' },
                ],
                limitTime: [
                    { required: true, message: '请输入考试时长', trigger: 'change' },
                    { pattern: /\d/, message: '请输入数字', trigger: 'blur' }
                ],
                qualifiedScore: [
                    { required: true, message: '请输入合格分数线', trigger: 'change' },
                    { pattern: /\d/, message: '请输入数字', trigger: 'blur' }
                ],
                limitNum: [
                    { required: true, message: '请输入允许考试次数', trigger: 'change' },
                    { pattern: /\d/, message: '请输入数字', trigger: 'blur' }
                ],
                timeRange: [
                    { required: true, message: '请选择考试进出截止时间', trigger: 'change' },
                ],
                checkRule: [
                    { required: true, message: '请选择查看试卷规则', trigger: 'change' },
                ]
            },
            type: 0,
            typeObj: {
                0: '',
                1: '试题组卷',
                2: '随机组卷',
                3: '选择试卷'
            },
            tableData: [
                {catalog1: '共计'},
                {catalog1: '总计', catalog2: '数量'},
                {catalog1: '总计', catalog2: '总分数'}
            ]
        }
    },
    methods: {
        // 弹窗-考试保存
        handleExamDialogSave(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.type === 2) {
                        if (this.configIds.length === 0) {
                            this.$message({ type: 'warning', message: '请关联卷宗' })
                            return
                        }
                        this.form.configIds = this.configIds
                    }
                    if (this.type === 3) {
                        if (!this.examPaperId) {
                            this.$message({ type: 'warning', message: '请关联卷宗' })
                            return
                        }
                        this.form.examPaperId = this.examPaperId
                    }
                    if (this.type === 1) {
                        if (this.questionItems.length === 0) {
                            this.$message({ type: 'warning', message: '请关联卷宗' })
                            return
                        }
                    }
                    this.$emit('confirmDailog', this.form)
                } else {
                    return false;
                }
            })
        },
        examTypeChange(type) {
            const isRefresh = this.type === type ? false : true
            this.type = type
            this.$emit('examTypeChange', type, isRefresh)
        },
        // 弹窗-考试关闭
        handleExamDialogClose() {
            this.$emit('closeDialog')
        }
    },
    watch: {
        visible(val) {
            if (val) {
                this.type = 0
                this.$nextTick(() => {
                    this.$refs.examDialogForm.resetFields()
                })
            }
        }
    }
}
</script>